import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './free-text.component.html',
    standalone: false
})
export class InstallationFreeTextPluginComponent {
  public textes: any[];
  public config: any;
  public editRoute = ['installation', 'freetext', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    if (this.config.Textes?.length) {
      this.textes = this.config.Textes;
    } else {
      this.textes = this.config.HtmlContent ? [{ Label: this.config.Label, HtmlContent: this.config.HtmlContent }] : [];
    }
  }
}
PluginComponent.plugins['installationfreetext'] = InstallationFreeTextPluginComponent;
